import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "brand-apartment-audit",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        phone: this.$route.query.phone,
        brandStatus: this.$route.query.brandStatus == "all" ? "" : 3
      },
      // 搜索表单

      filterList: [],
      districtList: [],
      adminList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0 // 总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getHouseFilterType();
            _this.getAdminList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getAdminList: function getAdminList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getAdminUser({
                type: "all"
              });
            case 1:
              res = _context2.v;
              _this2.adminList = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/house/update",
        query: {
          id: row.id,
          userId: row.userInfo.id,
          from: this.$operationLog.editFrom({
            user_type: row.userInfo.user_type,
            status: row.status
          })
        }
      });
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var price, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pn = 1;
              }
              if (_this3.searchForm.priceId && _this3.searchForm.priceId.length > 0) {
                price = _this3.searchForm.priceId.split(",");
                _this3.searchForm.minPrice = price[0];
                _this3.searchForm.maxPrice = price[1];
              }
              _this3.searchForm.type = 2; // 待审核
              _this3.searchForm.isBrand = 1;
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getHouseList(_this3.searchForm);
            case 1:
              res = _context3.v;
              _this3.tableData = res.data.list;
              _this3.total = res.data.count;
              _this3.tableLoading = false;
              _this3.tableData.forEach(function (item) {
                item.userId = item.userInfo.id;
              });
              _this3.getUserListByIds(_this3.tableData, "userId", '', "NewUser");
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getHouseFilterType: function getHouseFilterType() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.getHouseFilterType();
            case 1:
              res = _context4.v;
              _this4.filterList = res.data;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getDistrictList: function getDistrictList(val) {
      var _this5 = this;
      if (val) {
        this.filterList.cityList.forEach(function (value) {
          if (value.id === val) {
            _this5.searchForm.districtId = "";
            _this5.districtList = value.item;
          }
        });
      } else {
        this.districtList = [];
      }
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row;
      if (row.isSensitive) {
        return "warning-row";
      }
      if (row.blackIp) {
        return "black-ip-row";
      }
      if (row.censor_status == "block") {
        return "warning-row";
      }
      return "";
    }
  }
};